"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giuliano-terme": {
    "b3222cba": [{
      "hkey": "405a98fc",
      "slug": "mezzana-colignola",
      "name": "Mezzana-Colignola",
      "primary": true,
      "skipSearch": false
    }],
    "colignola": [{
      "hkey": "405a98fc",
      "slug": "mezzana-colignola",
      "name": "Mezzana-Colignola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giuliano-terme"
    }],
    "cd8c876f": [{
      "hkey": "28dce8e8",
      "slug": "colognole-patrignone",
      "name": "Colognole-Patrignone",
      "primary": true,
      "skipSearch": false
    }],
    "colognole": [{
      "hkey": "28dce8e8",
      "slug": "colognole-patrignone",
      "name": "Colognole-Patrignone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "81a41252": [{
      "hkey": "405a98fc",
      "slug": "mezzana-colignola",
      "name": "Mezzana-Colignola",
      "primary": true,
      "skipSearch": false
    }],
    "mezzana": [{
      "hkey": "405a98fc",
      "slug": "mezzana-colignola",
      "name": "Mezzana-Colignola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giuliano-terme"
    }],
    "43eaa6bb": [{
      "hkey": "0cece159",
      "slug": "pappiana-pontasserchio",
      "name": "Pappiana-Pontasserchio",
      "primary": true,
      "skipSearch": false
    }],
    "pappiana": [{
      "hkey": "0cece159",
      "slug": "pappiana-pontasserchio",
      "name": "Pappiana-Pontasserchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giuliano-terme"
    }],
    "e7241286": [{
      "hkey": "0cece159",
      "slug": "pappiana-pontasserchio",
      "name": "Pappiana-Pontasserchio",
      "primary": true,
      "skipSearch": false
    }],
    "pontasserchio": [{
      "hkey": "0cece159",
      "slug": "pappiana-pontasserchio",
      "name": "Pappiana-Pontasserchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giuliano-terme"
    }]
  }
};
exports["default"] = _default;